import Login from './App/public/components/user/Login.vue'
import Reset from './App/public/components/user/Reset.vue'
import Logout from './App/public/components/user/Logout.vue'
import Dashboard from './App/public/components/dashboard/Dashboard.vue'
import Home from './App/public/components/home/Home.vue'
import Translation from './App/public/components/translations/Translation.vue'
import TranslationList from './App/protected/components/translations/TranslationList.vue'


import UserList from './App/protected/components/user/UserList.vue'
import UserEdit from './App/protected/components/user/UserEdit.vue'
import UserCreate from './App/protected/components/user/UserCreate.vue'
import CustomerList from './App/protected/components/customer/CustomerList.vue'
import CustomerCreate from './App/protected/components/customer/CustomerCreate.vue'
import MyProfile from './App/protected/components/user/MyProfile.vue'
import Clients from './App/protected/components/clients/Clients.vue'
import Client from './App/protected/components/clients/Client.vue'
import ClientEdit from './App/protected/components/clients/ClientEdit.vue'
import ClientCreate from './App/protected/components/clients/ClientCreate.vue'
import History from './App/protected/components/history/History.vue'

import store from './Banet/store/store';

let storeRoles = store.getters.getRoles;
// defined in store/modules/user
// roles: ['god4all', 'admin', 'client', 'user', 'client-admin', 'any']
let allRolesArr = storeRoles.roles;
const lastIndex = allRolesArr.length -1;
const allRoles = allRolesArr.join('.');
const registeredRoles = allRolesArr.slice(0, lastIndex).join('.');
const adminRoles = allRolesArr.slice(0, 2).join('.');
const clientRoles = allRolesArr.slice(2, lastIndex).join('.');
const adminAndClientRoles = allRolesArr.slice(0, 4).join('.');
const allAdmins = allRolesArr.slice(0, 5).join('.');

export const routes = [
   {path: '/reset/:token',                      component: Reset,                   meta: { permission: 'reset' }},
   {path: '/login',                             component: Login,                   meta: { permission: allRoles }},
   {path: '/',                                  component: Dashboard,               meta: { permission: clientRoles },
   children: [
      {path: '',                                component: Home,                    meta: { permission: clientRoles }},
      {path: '/logout',                         component: Logout,                  meta: { permission: allRoles }},
      {path: 'users',                           component: UserList,                meta: { permission: adminAndClientRoles }},
      {path: 'user/:id',                        component: UserEdit,                meta: { permission: adminAndClientRoles }},
      {path: 'adduser/:id?',                    component: UserCreate,              meta: { permission: adminAndClientRoles }},
      {path: 'customers',                       component: CustomerList,            meta: { permission: adminAndClientRoles }},
      {path: 'addcustomer/:id?',                component: CustomerCreate,          meta: { permission: adminAndClientRoles }},
      {path: 'translate',                       component: Translation,             meta: { permission: adminRoles }},
      {path: 'translations',                    component: TranslationList,         meta: { permission: adminRoles }},
      {path: 'myprofile',                       component: MyProfile,               meta: { permission: registeredRoles }},
      {path: 'clients',                         component: Clients,                 meta: { permission: adminRoles }},
      {path: 'client/:id',                      component: Client,                  meta: { permission: adminRoles }},
      {path: 'client/edit/:id',                 component: ClientEdit,              meta: { permission: adminRoles }},
      {path: 'clientcreate',                    component: ClientCreate,            meta: { permission: adminRoles }},
      {path: 'history',                         component: History,                 meta: { permission: adminRoles }},
      {path: 'history/:model',                  component: History,                 meta: { permission: allAdmins }},
      {path: 'history/:model/:treated',         component: History,                 meta: { permission: allAdmins }},
      {path: 'history/:model/:treated/:client', component: History,                 meta: { permission: allAdmins }}
   ]}
];


// WEBPACK FOOTER //
// ./src/routes.js